import { FiGithub, FiGlobe, FiLinkedin, FiTwitter, FiYoutube } from 'react-icons/fi';
import { BrandLogo } from '../../../../_UI/BrandLogo';

const ICONS = { github: FiGithub, linkedin: FiLinkedin, twitter: FiTwitter, 'twitter-x': FiTwitter, youtube: FiYoutube, web: FiGlobe };

export const PortfolioFooter = ({ profile = {}, socials = [] }) => (
    <footer className="PB__footer">
        <div className="PB__container PB__footer_inner">
            <div className="PB__footer_brand_block">
                {/* LOGO: reemplazar public/_Imgs/_Brand/LS_BRAND_dark.png */}
                <BrandLogo slot="FOOTER_PUBLIC" className="PB__footer_logo" fallback={profile.brand || 'Bailador'} />
                <p>{profile.footer_text || `© ${new Date().getFullYear()} · Codigo con criterio y proposito.`}</p>
            </div>
            <div className="PB__footer_socials">
                {socials.map((social) => {
                    const Icon = ICONS[String(social.network || '').toLowerCase()] || FiGlobe;
                    return <a key={social.id || social.network} href={social.url} target="_blank" rel="noreferrer" aria-label={social.label || social.network}><Icon /></a>;
                })}
            </div>
        </div>
    </footer>
);
